module.exports = __webpack_public_path__ + "img/ListOfFeaturedAmenities.607f3ff8.png";